<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { IncidentSearchPeriod } from '@roadfootage/api-client'

import { parseSearchQuery, toSearchQuery } from '../utils/search-route'

withDefaults(
  defineProps<{
    autofocus?: boolean
    dense?: boolean
  }>(),
  { autofocus: false, dense: true }
)

const router = useRouter()
const route = useRoute()

const text = ref('')

// On the results page the box mirrors the URL, so back/forward and shared links show what was searched.
watch(
  () => [route.name, route.query.q] as const,
  ([name]) => {
    if (name === 'search') text.value = parseSearchQuery(route.query).q
  },
  { immediate: true }
)

function submit() {
  const q = (text.value ?? '').trim()
  if (!q) return
  // Keep the filters when searching again from the results page; start clean from anywhere else.
  const current =
    route.name === 'search'
      ? parseSearchQuery(route.query)
      : { q, hasFootage: false, period: IncidentSearchPeriod.Any }
  router.push({ name: 'search', query: toSearchQuery({ ...current, q }) })
}
</script>

<template>
  <form role="search" class="incident-search-box" @submit.prevent="submit">
    <q-input
      v-model="text"
      type="search"
      outlined
      rounded
      bg-color="white"
      :dense="dense"
      :autofocus="autofocus"
      placeholder="Search incidents"
      aria-label="Search incidents"
      enterkeyhint="search"
      maxlength="100"
      clearable
      clear-value=""
    >
      <template #prepend>
        <q-icon name="mdi-magnify" />
      </template>
    </q-input>
  </form>
</template>
